import { AbpOAuthService } from '@abp/ng.oauth';
import { Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { environment } from 'src/environments/environment';
import { AutoLogoutComponent } from '../common-dialog/auto-logout/auto-logout.component';
@Injectable({ providedIn: 'root' })
export class AutoLogoutService {
  private dialogOpened = false;
  private dialogRef?: DialogRef;

  constructor(
    private readonly idle: Idle,
    public readonly dialogService: DialogService,
    public readonly abpOauthService: AbpOAuthService
  ) {
    this.configureIdle();
  }

  configureIdle(): void {
    this.idle.setIdle(environment.idleTimeoutSeconds);
    this.idle.setTimeout(60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeout.subscribe(() => {
      this.idle.stop();
      this.dialogOpened = false;
      this.dialogRef?.close();
      this.abpOauthService.logout();
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      if (!this.dialogOpened) {
        this.dialogOpened = true;

        this.idle.clearInterrupts();

        this.dialogRef = this.dialogService.open({
          content: AutoLogoutComponent,
          width: '50%',
        });

        this.dialogRef.result.subscribe((res) => {
          if (res === 'continue') {
            this.dialogOpened = false;
            this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
            this.resetTimer();
          }
        });
      }
    });


    this.idle.watch();
  }

  resetTimer(): void {
    this.idle.watch();
  }

  logout(): void {
    this.idle.stop();
    this.abpOauthService.logout();
  }
}
